export const printError = (error) => {
    const payloadMessage = error?.response?.data?.payload?.message;
    const dataMessage = error?.response?.data?.message;
    const errorMessage = error?.message;

    if (payloadMessage) {
        return payloadMessage;
    } else if (dataMessage) {
        return dataMessage;
    } else if (errorMessage) {
        return errorMessage;
    } else return false;
};
